export class SituacaoConsumidorReferenciaSorteioModel {

  public consumidorId: number;
  public statusParticipanteSorteio: number;
  public situacaoCadastroConsumidorId: number;
  public seqSorteioPremiacaoConsumidor: number;
  public dtc_realizacao_sorteiro_premiacao_consumidor: Date;
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/situacao-consumidor-referencia-sorteio.model.ts